import { Sheet, SheetContent, SheetHeader, SheetTitle } from '@features/ui';
import { cn } from '@lib/utils';
import { MenuIcon } from 'lucide-react';
import { FC, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, Navigate, Outlet, useLocation } from 'react-router-dom';
import { useGetMe } from '@hooks/useGetMe.ts';

const renewNavItems = [
  {
    label: 'checkout.selectAccount',
    href: '/renew/select-account',
  },
  {
    label: 'checkout.checkout',
    href: '/renew/review-checkout',
  },
];

interface Props {
  isCreatePaAccount?: boolean;
}
export const RenewLayout: FC<Props> = ({ isCreatePaAccount }) => {
  const [openDrawer, setOpenDrawer] = useState(false);

  const { t } = useTranslation();
  const location = useLocation();
  const { me, loading } = useGetMe();

  const navItems = useMemo(() => {
    if (isCreatePaAccount) {
      return [];
    }

    return renewNavItems;
  }, [isCreatePaAccount]);

  if (!me?.id && !loading) {
    return <Navigate replace={true} to={'/signin'} />;
  }

  return (
    <>
      <header className="flex justify-between items-center max-w-[1440px] m-auto p-6 pb-12 lg:px-[60px] lg:py-10">
        <img alt="logo" src="/assets/logo.svg" />
        <nav className="hidden lg:flex items-center gap-x-8">
          {navItems.map((item) => (
            <Link
              key={item.label}
              className={cn(
                'text-[23px]',
                location.pathname.includes(item.href)
                  ? 'text-secondary underline'
                  : ''
              )}
              to={item.href}
            >
              {t(item.label)}
            </Link>
          ))}
        </nav>
        <MenuIcon
          className="lg:hidden cursor-pointer"
          height={32}
          width={32}
          onClick={() => setOpenDrawer(true)}
        />
        <Sheet open={openDrawer} onOpenChange={setOpenDrawer}>
          <SheetContent className="gap-0 pt-14">
            {navItems.map((item) => (
              <SheetHeader
                key={item.label}
                className={cn(
                  location.pathname.includes(item.href) ? 'bg-accent' : ''
                )}
              >
                <SheetTitle className="hover:text-link">
                  <Link
                    className={cn(
                      'text-xl',
                      location.pathname.includes(item.href) ? 'text-link' : ''
                    )}
                    to={item.href}
                    onClick={() => setOpenDrawer(false)}
                  >
                    {t(item.label)}
                  </Link>
                </SheetTitle>
              </SheetHeader>
            ))}
          </SheetContent>
        </Sheet>
      </header>
      <div className="max-w-[1440px] m-auto px-6 lg:px-[60px]">
        <Outlet />
      </div>
    </>
  );
};
